import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addCommission, removeCommission } from 'bundles/apex/deals/form/store/deal/actions';

import Broker from './broker';
import Collection from 'bundles/apex/deals/form/fields/collection';
import DealField from 'bundles/apex/deals/form/fields/field';
import { filterCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';
import { rejectUsedBrokerOptions } from 'bundles/apex/deals/helpers/commissions';

export function InternalBrokers({
  addCommission,
  deal,
  forUser,
  invalid,
  removeCommission,
  restrictBrokerGrossVisibilityToSelf,
  transactionSide,
  userOptions
}) {
  const commissions = filterCommissions(deal.commissions, transactionSide, false);
  const availableOptions = rejectUsedBrokerOptions(userOptions, commissions, transactionSide);

  function clear() {
    removeCommission(commissions[0]);
    addCommission({ outside: false, transactionSide });
  }

  return (
    <Collection
      addLabel="Add Broker"
      full={!availableOptions.length}
      hasValue={!!commissions[0]?.broker}
      onAdd={() => addCommission({ outside: false, transactionSide })}
      onClear={clear}
      onRemoveIndex={index => removeCommission(commissions[index])}
    >
      {commissions.map((commission, i) => {
        let disableCommisionView = false;
        const isNewDeal = !deal.id;
        if (restrictBrokerGrossVisibilityToSelf && forUser?.id && commission?.broker && !isNewDeal) {
          disableCommisionView = !forUser.apexAdmin && commission.broker.id !== forUser.id;
        }

        return (
          <Broker
            commission={commission}
            disableCommisionView={disableCommisionView}
            invalid={!i && invalid}
            key={commission.id || commission.localId}
            options={availableOptions}
            primary={!i}
            removable={!commission.id || !deal.voucher}
            transactionSide={transactionSide}
          />
        );
      })}
    </Collection>
  );
}

InternalBrokers.propTypes = {
  addCommission: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      localId: PropTypes.string,
      outside: PropTypes.bool,
    })).isRequired,
    voucher: PropTypes.object,
  }),
  forUser: PropTypes.shape({
    apexAdmin: PropTypes.bool,
    id: PropTypes.number.isRequired,
  }),
  invalid: PropTypes.bool,
  removeCommission: PropTypes.func.isRequired,
  restrictBrokerGrossVisibilityToSelf: PropTypes.bool,
  transactionSide: PropTypes.string,
  userOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  forUser: state.forUser,
  restrictBrokerGrossVisibilityToSelf: state.features.restrictBrokerGrossVisibilityToSelf,
  userOptions: state.options.users,
});

const mapDispatchToProps = {
  addCommission,
  removeCommission,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealField(InternalBrokers, 'internalBrokers'));
